var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkAllAsRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "notification_multiple"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3488_2150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3488_2150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "notification_multiple_2",
    d: "M2.96474 17.1303C2.54381 17.1303 2.18751 16.9845 1.89584 16.6928C1.60418 16.4011 1.45834 16.0448 1.45834 15.6239V5.52779H2.70832V15.6239C2.70832 15.6987 2.73236 15.7601 2.78045 15.8082C2.82852 15.8563 2.88995 15.8803 2.96474 15.8803H14.5833V17.1303H2.96474ZM11.4583 10.5406L5.62495 7.12392V12.7073C5.62495 12.7821 5.64899 12.8435 5.69707 12.8916C5.74516 12.9397 5.80659 12.9637 5.88139 12.9637H17.0352C17.11 12.9637 17.1714 12.9397 17.2195 12.8916C17.2676 12.8435 17.2916 12.7821 17.2916 12.7073V7.12392L11.4583 10.5406ZM5.88139 14.2137C5.46044 14.2137 5.10414 14.0678 4.81249 13.7762C4.52082 13.4845 4.37499 13.1282 4.37499 12.7073V5.9605C4.37499 5.70622 4.42894 5.47385 4.53684 5.2634C4.64475 5.05292 4.81729 4.87931 5.05447 4.74256L11.4583 0.976562L13.2355 2.02463L12.3061 2.92844L11.4583 2.43806L5.79161 5.7714L11.4583 9.10473L17.1249 5.7714L15.9599 5.07267L16.8637 4.16883L17.8621 4.74256C18.0993 4.87931 18.2718 5.05292 18.3797 5.2634C18.4876 5.47385 18.5416 5.70622 18.5416 5.9605V12.7073C18.5416 13.1282 18.3958 13.4845 18.1041 13.7762C17.8124 14.0678 17.4561 14.2137 17.0352 14.2137H5.88139ZM11.3012 7.72329L9.25639 5.67844L10.1346 4.80025L11.3012 5.96692L15.1762 2.09192L16.0544 2.9701L11.3012 7.72329Z",
    fill: "#1D4650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAllAsRead);
export default __webpack_public_path__ + "static/media/mark-all-as-read.aab21cce1d9bf0a62e993088058abfa6.svg";
export { ForwardRef as ReactComponent };